var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueMarkerFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#2E63EE",
    d: "m21.72,16.0499c0,2.87 -2.32,5.19 -5.19,5.19c-2.87,0 -5.19,-2.32 -5.19,-5.19c0,-2.87 2.32,-5.19 5.19,-5.19c2.87,0 5.19,2.32 5.19,5.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#00C9B8",
    d: "m16.53,17.62c0.8671,0 1.57,-0.7029 1.57,-1.57c0,-0.8671 -0.7029,-1.57 -1.57,-1.57c-0.8671,0 -1.57,0.7029 -1.57,1.57c0,0.8671 0.7029,1.57 1.57,1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#2E63EE",
    d: "m9.64001,40.03l14.35999,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    d: "m13.47561,5.68292",
    opacity: "NaN",
    fill: "#2E63EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.69513,6.85365c0,0 -0.09756,0.09756 -0.4878,0.29268c-0.58537,0.29268 -0.99115,0.44982 -1.26829,0.58537c-0.31599,0.15455 -0.64498,0.28567 -0.87805,0.4878c-0.1648,0.14293 -0.23988,0.26277 -0.29268,0.39024c-0.03733,0.09013 0,0.19512 0,0.29268c0,0 0,0.09756 0,0.19512c0,0 0,0.09756 0,0.19512c0,0 0,0.09756 0,0.09756c0,0.09756 0,0.09756 0,0.19512c0,0 0.09756,0.09756 0.09756,0.09756c0,0 0.09756,0.09756 0.09756,0.19512c0,0 0,0.09756 0,0.29268c0,0.29268 0.03031,0.48875 0,0.97561c-0.04887,0.78504 -0.46807,1.76539 -1.07317,3.02439c-0.37801,0.78649 -0.68293,1.36585 -0.97561,1.85366c-0.29268,0.48781 -0.56526,0.98414 -0.78049,1.46342c-0.17874,0.39802 -0.33025,0.81678 -0.58537,1.17073c-0.16135,0.22386 -0.34012,0.47061 -0.39024,0.68293c-0.04483,0.1899 -0.08193,0.3915 -0.09756,0.4878c-0.04942,0.30453 -0.09756,0.39024 -0.09756,0.39024c0,0.09756 -0.09756,0.09756 -0.09756,0.09756l-0.09756,0.09756l0,0l-0.19512,-0.09756",
    id: "svg_8",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#2E63EE",
    d: "m15.67244,37.95244c0.44,0.37 1.08,0.37 1.52,0c3.01,-2.53 13.9,-12.35 13.9,-21.74c0,-7.92003 -6.56,-14.33002 -14.66,-14.33002c-8.1,0 -14.66,6.41999 -14.66,14.33002c0,9.39 10.89,19.2 13.89,21.74l0.01,0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 17.41463,
    rx: 1.95122,
    id: "svg_10",
    cy: 23.4878,
    cx: 39.62195,
    strokeWidth: 2,
    stroke: "#2E63EE"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_46",
    y2: 13.4878,
    x2: 6.64635,
    y1: 7.04877,
    x1: 12.40244,
    strokeWidth: 9,
    stroke: "#2E63EE",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_47",
    y2: 18.75609,
    x2: 5.57318,
    y1: 35.24389,
    x1: 19.13415,
    strokeWidth: 9,
    stroke: "#2E63EE",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_50",
    y2: 16.2195,
    x2: 28.20732,
    y1: 6.17073,
    x1: 20.0122,
    strokeWidth: 9,
    stroke: "#2E63EE",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_54",
    y2: 6.46341,
    x2: 23.03659,
    y1: 7.63414,
    x1: 12.59756,
    strokeWidth: 9,
    stroke: "#2E63EE",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_55",
    y2: 29.68292,
    x2: 18.35366,
    y1: 19.43902,
    x1: 27.03659,
    strokeWidth: 9,
    stroke: "#2E63EE",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_56",
    y2: 21.4878,
    x2: 25.96342,
    y1: 12.70731,
    x1: 26.7439,
    strokeWidth: 9,
    stroke: "#2E63EE",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_57",
    y2: 25.39023,
    x2: 19.71951,
    y1: 24.12194,
    x1: 11.03659,
    strokeWidth: 9,
    stroke: "#2E63EE",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_60",
    y2: 21.39023,
    x2: 5.7683,
    y1: 10.85365,
    x1: 8.20732,
    strokeWidth: 9,
    stroke: "#2E63EE",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_61",
    y2: 9.19512,
    x2: 10.2561,
    y1: 5.19512,
    x1: 18.84147,
    strokeWidth: 9,
    stroke: "#2E63EE",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMarkerFilled);
export default __webpack_public_path__ + "static/media/blue-marker-filled.7bbff84ec2deb981bd23ceb7d550eaaa.svg";
export { ForwardRef as ReactComponent };